import { media, styled } from '@styles';
import { css } from 'styled-components';

import chevronLeftImage from 'images/chevron_left.svg';
import chevronRightImage from 'images/chevron_right.svg';

const slickArrow = css`
  .slick-arrow {
    width: 56px;
    height: 56px;
    z-index: 3;
    color: transparent;
    background-color: #fff;
    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);
    border-radius: 50%;
    position: absolute;
    transform: translateY(-50%);
    ${media.largeScreen`
      width: 50px;
      height: 50px;
    `}
    ${media.smallScreen`
      display: none !important;
    `}
  }
`;

const slickPrev = css`
  .slick-prev {
    background: url(${chevronLeftImage}) no-repeat center !important;
    background-size: contain;
    left: -120px;
    top: 50%;
    ${media.largeScreen`
      left: -71px;
    `}
    ${media.mediumScreen`
      left: -82px;
    `}
  }
`;

const slickNext = css`
  .slick-next {
    background: url(${chevronRightImage}) no-repeat center !important;
    background-size: contain;
    right: -120px;
    top: 50%;
    ${media.largeScreen`
      right: -71px;
    `}
    ${media.mediumScreen`
      right: -82px;
    `}
  }
`;

export const Wrapper = styled.div`
  width: 50vw;
  max-width: 960px;
  margin: 0 auto;
  position: relative;
  ${media.largeScreen`
    width: 54vw;
    max-width: 690px;
  `}
  ${media.mediumScreen`
    width: 62vw;
    max-width: 476px;
  `}
  ${media.smallScreen`
    max-width: 360px;
    width: 85vw;
  `}
  ${slickArrow}
  ${slickPrev}
  ${slickNext}
`;

export const Item = styled.div`
  width: 100%;
  padding-top: 60%;
  position: relative;
  video {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    object-fit: contain;
    background-color: #000000;
  }
  img {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    object-fit: cover;
  }
`;
